import UserInfoCard from './UserInfoCard';

export default UserInfoCard;
